import { createFeatureSelector, createSelector } from '@ngrx/store';
import { compareDate, getUtcTime } from 'src/utils';
import * as fromReporting from './reporting.reducers';
import { processReports } from 'src/utils/reports.utils';

export const selectReportingState = createFeatureSelector<fromReporting.State>('reporting');
export const selectReporting = createSelector(selectReportingState, (state) => state);

export const selectLocalReports = createSelector(selectReporting, fromReporting.getLocalReports);

export const selectReports = createSelector(selectLocalReports, (localReports) => {
  const processedReports = processReports(localReports);
  return processedReports;
});

export const selectCurrentReport = createSelector(selectReportingState, ({ currentReport }) => currentReport);
export const selectPreviousReport = createSelector(selectReportingState, ({ currentReport, localReports }) => {
  let currentReportDate = new Date(currentReport.reportDate as Date);
  if (currentReport.localTime && currentReport.timezone) {
    currentReportDate = getUtcTime(currentReportDate, currentReport.localTime, currentReport.timezone);
  }
  return [...localReports]
    .map((report) => {
      return {
        ...report,
        reportDate: new Date(report.reportedTime),
      };
    })
    .sort(({ reportDate: a }, { reportDate: b }) => compareDate(a as Date, b as Date, false))
    .find(
      ({ reportDate, id }) =>
        new Date(reportDate).getTime() < new Date(currentReportDate).getTime() && id !== currentReport.id
    );
});
export const selectSelectedBunkers = createSelector(selectReporting, fromReporting.getSelectedBunkerTypes);
export const selectError = createSelector(selectReporting, ({ error }) => error);
export const selectDebugLog = createSelector(selectReporting, ({ log }) => log);
export const selectShipReportingRequirements = createSelector(
  selectReporting,
  (state) => state?.shipReportingRequirements ?? fromReporting.initialState.shipReportingRequirements
);

export const selectShip = createSelector(selectReporting, fromReporting.getShip);
export const selectBioBlends = createSelector(selectReporting, fromReporting.getBioBlends);

export const { reducer: reportingReducer } = fromReporting;
